/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { GridContext } from '../contexts';

import type { GridStore } from '../stores';

export const useGridApi = <
    RowDataT,
    TotalRowDataT,
    FilterT
>(): GridStore<RowDataT, TotalRowDataT, FilterT> => useContext(GridContext);
